
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('ProjectRewards', function (Parse, ProjectRewardSchema) {


		/**
		 * Retrieve the list of projects
		 */
		this.list = () => {
			let query = new Parse.Query(ProjectRewardSchema);
			query.include('image');
			return query.find();
		};


		/**
		 * Returns the count of all project rewards
		 */
		this.count = () => {
			let query = new Parse.Query(ProjectRewardSchema);
			return query.count();
		}


		/**
		 * Retrieve a project reward by ID
		 */
		this.get = (id, options = {}) => {
			let query = new Parse.Query(ProjectRewardSchema);
			query.include('image');
			if (typeof options.include !== 'undefined') {
				query.include(options.include);
			}
			return query.get(id);
		}
		
		
	});
}




// WEBPACK FOOTER //
// ./src/app/core/services/project-rewards.service.js